/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section4_P1Inputs */

const en_about_section4_p1 = /** @type {(inputs: About_Section4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON is built with modern web technologies: SvelteKit for the framework, Monaco Editor (the same editor used in VS Code) for code editing, and Tailwind CSS for styling. The app is deployed on Cloudflare Pages for global performance.`)
};

const ko_about_section4_p1 = /** @type {(inputs: About_Section4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 최신 웹 기술로 구축되었습니다: 프레임워크로 SvelteKit, 코드 편집을 위한 Monaco Editor(VS Code에서 사용하는 것과 동일한 에디터), 스타일링을 위한 Tailwind CSS. 앱은 글로벌 성능을 위해 Cloudflare Pages에 배포됩니다.`)
};

const ja_about_section4_p1 = /** @type {(inputs: About_Section4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONは最新のWeb技術で構築されています：フレームワークにSvelteKit、コード編集にMonaco Editor（VS Codeで使用されているのと同じエディター）、スタイリングにTailwind CSS。アプリはグローバルなパフォーマンスのためにCloudflare Pagesにデプロイされています。`)
};

/**
* | output |
* | --- |
* | "PureJSON is built with modern web technologies: SvelteKit for the framework, Monaco Editor (the same editor used in VS Code) for code editing, and Tailwind C..." |
*
* @param {About_Section4_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section4_p1 = /** @type {((inputs?: About_Section4_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section4_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section4_p1(inputs)
	if (locale === "ko") return ko_about_section4_p1(inputs)
	return ja_about_section4_p1(inputs)
});